import { FC } from "react"

import { useTimezone } from "hooks/useTimezone"

import { formatFiatCurrency } from "util/formatter"

import { StatOption } from "./statsConfig"

type Granularity = "year" | "month" | "day" | "hour"

type TooltipEntry = {
  dataKey: string
  value: number
  color?: string
}

interface Props {
  active?: boolean
  payload?: TooltipEntry[]
  label?: string

  granularity: Granularity
  options: StatOption[]
  currencyStats: Set<string>
}

export const ChartTooltipContent: FC<Props> = ({ active, payload, label, granularity, options, currencyStats }) => {
  const { formatDateTime } = useTimezone()

  if (!active || !payload || payload.length === 0) return null

  const title = granularity === "year" ? label : label ? formatDateTime(label) : ""

  return (
    <div className="p-3 bg-zinc-800 border border-gray-600 rounded text-sm text-white">
      <div className="font-bold mb-2">{title}</div>

      <ul className="space-y-1">
        {payload.map((entry) => {
          const statKey = entry.dataKey
          const statMeta = options.find((opt) => opt.value === statKey)
          const formattedVal = currencyStats.has(statKey) ? formatFiatCurrency(Number(entry.value ?? 0)) : entry.value

          return (
            <li key={statKey} className="flex justify-between gap-4">
              <span style={{ color: entry.color }}>{statMeta?.label || statKey}</span>
              <span>{formattedVal}</span>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
